import type React from 'react';

import useGlobalStyles from '@/styles/global.styles';

interface BulletedListProps {
  classes: Record<string, string>;
  bulletedListTitle?: string;
  bulletedList?: string[];
}

const BulletedList: React.FC<BulletedListProps> = ({
  classes,
  bulletedList,
  bulletedListTitle,
}) => {
  const { classes: globalClasses, cx } = useGlobalStyles({ fixed: true });

  return (
    <>
      <h4
        className={cx(
          globalClasses.body,
          classes.listTitle,
          classes.bulletedListTitle
        )}
      >
        {bulletedListTitle}
      </h4>
      <ul
        className={cx(globalClasses.bodySm, classes.bulletedList, classes.list)}
      >
        {bulletedList?.map((item, index) => (
          <li
            key={`${item}-${
              // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
              index
            }`}
          >
            {item}
          </li>
        ))}
      </ul>
    </>
  );
};

export default BulletedList;
